import { deepAnalyses } from "@/mocks/home";

export default function DeepAnalysis() {
  const [featured, ...others] = deepAnalyses;

  return (
    <section id="reports" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-site px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <i className="ri-article-line text-sm"></i>
              DEEP REPORTS
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              深度解析
            </h2>
          </div>
          <p className="max-w-md text-sm leading-7 text-foreground-600">
            每一份解析报告都从原始信源出发，逐条核对后再下结论，而不是复述热度最高的那一种说法。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-6">
            <div className="h-64 w-full overflow-hidden md:h-[360px]">
              <img
                src={featured.image}
                alt={featured.title}
                title={`${featured.title} · 17黑料网深度解析`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                  {featured.angle}
                </span>
                <span className="text-xs text-foreground-400">{featured.reportNo}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                {featured.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{featured.excerpt}</p>
              <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  {featured.readTime}阅读
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-refresh-line"></i>
                  更新于 {featured.updated}
                </span>
                <span className="ml-auto inline-flex items-center gap-1 font-medium text-primary-600">
                  查看解析
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-6 lg:col-span-6">
            {others.map((item) => (
              <article
                key={item.id}
                className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50/40 md:gap-5"
              >
                <div className="h-24 w-28 flex-shrink-0 overflow-hidden rounded-md md:h-28 md:w-40">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} · 17黑料网深度解析`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                      {item.angle}
                    </span>
                    <span className="text-[11px] text-foreground-400">{item.reportNo}</span>
                  </div>
                  <h3 className="mt-2 line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 hidden line-clamp-2 text-xs leading-6 text-foreground-600 sm:block">
                    {item.excerpt}
                  </p>
                  <div className="mt-auto flex flex-wrap gap-1.5 pt-2.5">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}